import { getMergeLead } from '@/shared/api';

export const landerDataBuildMergeLead = getMergeLead;
